import UserService from './user.service';

export default UserService;
